<template>
  <!-- 经纪人列表 -->
  <div id="agentRole">
    <!-- 头部数据更新时间模块 -->
    <!-- <headerUpdate></headerUpdate> -->
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <!-- 添加 -->
      <b-button class="add add-tab" variant="primary" @click="handleAdd">
        <!-- <svg class="icon icon-12 icon-search" aria-hidden="true">
            <use xlink:href="#icon-v4_7_h"></use>
          </svg> -->
        {{ $t("common.add") }}
      </b-button>
      <b-row>
        <b-col lg="9">
          <!--商户-->
          <b-form-group class="find-middle">
            <label v-if="!disabledBroker">
              {{ $t("common.clientName") }}
            </label>
            <v-select
              v-if="!disabledBroker"
              class="find-select"
              v-model="brokerId"
              :options="brokerList"
              :disabled="disabledBroker"
            >
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
            <!-- <div style="height: 64px" v-if="disabledBroker"></div> -->
          </b-form-group>

          <!--状态-->
          <b-form-group class="find-middle">
            <label v-if="!disabledBroker">
              {{ $t("returnLevel.t3") }}
            </label>
            <v-select
              v-if="!disabledBroker"
              class="find-select"
              v-model="status"
              :options="statusList"
              :disabled="disabledBroker"
            >
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn" v-if="!disabledBroker">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                        <use xlink:href="#icon-v4_17"></use>
                      </svg> -->
              {{ $t("common.search") }}</b-button
            >
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                        <use xlink:href="#icon-v4_3"></use>
                      </svg> -->
              {{ $t("common.reset") }}</b-button
            >
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table
            :height="$store.state.baseData.tableH"
            class="table-container"
            :data="tableList"
            @sort-change="sortChanged"
            :cell-class-name="addEnClass"
            :default-sort="{ prop: '', order: '' }"
          >
            <template slot="empty">
              <load-skeleton
                v-show="loading"
                :columns="6"
                :rows="10"
                :haveLeftNumber="false"
              ></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>

            <!-- 商户名称 -->
            <el-table-column
              prop="brokerName"
              :label="$t('returnLevel.t2')"
              align="left"
            >
            </el-table-column>

            <!-- 最高返佣等级 -->
            <el-table-column
              prop="maxLevel"
              :label="$t('lanV4.RebateratioLever')"
              align="right"
            >
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
              prop="status"
              :label="$t('returnLevel.t3')"
              align="right"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status === 0">
                  <!-- 关闭 -->
                  {{ $t("returnLevel.t10") }}
                </div>
                <div v-else>
                  {{ $t("returnLevel.t9") }}
                </div>
              </template>
            </el-table-column>

            <!--  添加时间-->
            <el-table-column
              prop="ctime"
              align="right"
              :label="$t('returnLevel.t5')"
            >
            </el-table-column>
            <!--  更新时间-->
            <el-table-column
              prop="mtime"
              align="right"
              :label="$t('returnLevel.t6')"
            >
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
              prop="action"
              :label="$t('common.find')"
              fixed="right"
              align="right"
            >
              <template slot-scope="scope">
                <!-- 编辑 -->
                <b-button
                v-if="!disabledBroker"
                  size="sm"
                  variant="outline-primary"
                  @click="handleEdit(scope.row)"
                >
                  {{ $t("common.editor") }}
                </b-button>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page
            v-if="pages.total > 0"
            :total-rows="pages.total"
            :perPage="pages.size"
            :pageOptions="pages.options"
            :currentPage="pages.page"
            @initialize="pageChange"
          ></v-page>
        </b-col>
      </b-row>
    </b-card>
    <agentReturnLevelModal
      v-if="modalShow"
      :modalShow="modalShow"
      :modalType="modalType"
      :itemData="itemData"
      @changeModalShow="changeModalShow"
      @changeModalType="changeModalType"
      @getParentData="getParentData"
    >
    </agentReturnLevelModal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime, multiply } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
import agentReturnLevelModal from "./components/agentReturnLevelModal.vue";

export default {
  name: "agentReturnLevel",
  mixins: [commonMixin],
  components: {
    headerUpdate,
    agentReturnLevelModal,
  },
  data() {
    return {
      brokerId: null, //商户id
      brokerList: [],
      status: null, //状态

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "", //默认排序字段
      sortSet: 1, //默认倒序
      modalType: null,
      itemData: null, //弹窗回显数据
    };
  },
  computed: {
    statusList() {
      return [
        { label: this.$t("common.all"), value: null }, //全部
        { label: this.$t("returnLevel.t9"), value: 1 }, //开启
        { label: this.$t("returnLevel.t10"), value: 0 }, //关闭
      ];
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    // brokerId(v) {
    //     if (v) {
    //         this.getData();
    //     }
    // },
  },
  created() {
    this.getBrokerList();
  },
  methods: {
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (this.roleType === 1) {
            arr.push({ label: this.$t("common.all"), value: null });
          }
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            this.brokerId = arr[0];
            this.status = this.statusList[0];
            this.getData();
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 获取返佣等级列表
    getParentData() {
      this.getData();
    },
    // 点击所含经纪人数跳转
    handleView(row) {
      const queryObj = {
        roleName: row.id, //id就是角色名称的value
      };
      this.$router.push({ path: "/agentList", query: queryObj });
    },
    // 删除弹窗关闭
    handlePopoverClose() {
      document.getElementById("agentRole").click();
    },
    // 添加
    handleAdd() {
      this.itemData = null;
      this.modalType = "Add";
      this.modalShow = true;
    },
    //编辑
    handleEdit(row) {
      this.modalType = "Edit";
      this.itemData = row;
      this.modalShow = true;
    },
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },

    // 箭头图标
    //   renderHeader (h, { column, $index }) {
    //    if (column.order === 'ascending') {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort-up"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_up.png"></img>
    //        </div>
    //      )
    //    } else if (column.order === 'descending') {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort-down"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_down.png"></img>
    //        </div>
    //      )
    //    } else {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_de.png"></img>
    //        </div>
    //      )
    //    }
    //  },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "agentNumber":
          this.sortName = "agentNumber";
          break;
      }
      if (ctx.order === "descending") {
        this.sortSet = 1;
      } else if (ctx.order === "ascending") {
        this.sortSet = 0;
      } else {
        this.sortSet = null;
        this.sortName = null;
      }
      this.getData();
    },
    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.brokerId = this.brokerList[0];
      this.status = this.statusList[0];
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        brokerId: this.brokerId ? this.brokerId.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        status: this.status ? this.status.value : null,
      };
      this.$http({
        url: "page_rebate_level",
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          console.log(data, "data");
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      console.log(datas, "datas");
      const { total, records } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (records && records.length) {
        records.map((item, index) => {
          arr.push({
            id: item.id,
            brokerName: item.brokerName, //商户名称
            brokerId: item.brokerId, //商户ID
            maxLevel: item.maxRebateLevel, //最高返佣等级
            status: item.status, //状态
            ctime: item.ctimeMiles ? formatTime(item.ctimeMiles) : "--", //添加时间
            mtime: item.mtimeMiles ? formatTime(item.mtimeMiles) : "--", //更新时间
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },

    changeModalShow(data) {
      this.modalShow = data;
    },
    changeModalType(data) {
      this.modalType = data;
    },
    onReset() {},
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentRole {
  .add-tab {
    position: absolute;
    top: 16px;
    right: 26px;
  }

  .custom-control {
    top: 5px !important;
  }

  .agent-number {
    color: #095be8;
    cursor: pointer;
  }
}
</style>
